const QuestionDetails = (state = [], action) => {
    switch (action.type) {
        case 'ModeratorQuestionDetails':
            return action.payload
        default:
            return state
    }
}
export default QuestionDetails